/* @flow */
import * as React from 'react';

type Props = {
  total: number,
  value: number,
};

export default function AdminStatisticsChartTooltipValuePercent({ total, value }: Props) {
  if (total <= 0 || value === 0) {
    return null;
  }

  return (
    <span>
      ({Math.round((value / total) * 100)}
      %)
    </span>
  );
}
